export const AUTH_FLOW = {
  HOME: 'HOME',
  OLD: 'OLD',
  COMPLETE_PROFILE: 'COMPLETE_PROFILE',
  EMAIL_ERROR: 17,
};
